import { useLayoutEffect, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTopRouter = ({ children }) => {
  const location = useLocation();
  const prevLocationKeyRef = useRef(`${location.pathname}${location.search}${location.hash}`);

  // useLayoutEffect runs synchronously BEFORE browser paint - this is critical
  useLayoutEffect(() => {
    const locationKey = `${location.pathname}${location.search}${location.hash}`;
    // Only scroll if location actually changed
    if (locationKey !== prevLocationKeyRef.current) {
      prevLocationKeyRef.current = locationKey;
      
      // Force scroll to top immediately - runs before React renders the new route
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
      
      // Also scroll root element if it exists
      const root = document.getElementById('root');
      if (root) {
        root.scrollTop = 0;
      }
      
      // Also try scrollIntoView as a fallback
      try {
        document.documentElement.scrollIntoView({ behavior: 'instant', block: 'start' });
      } catch (e) {
        // Ignore if not supported
      }
    }
  }, [location.pathname, location.search, location.hash]);

  // useEffect runs after render - additional safety net for async content
  useEffect(() => {
    const locationKey = `${location.pathname}${location.search}${location.hash}`;
    // Only scroll if location actually changed
    if (locationKey !== prevLocationKeyRef.current) {
      prevLocationKeyRef.current = locationKey;
      
      const scrollToTop = () => {
        window.scrollTo(0, 0);
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
        const root = document.getElementById('root');
        if (root) {
          root.scrollTop = 0;
      }
    };

      // Immediate scroll
      scrollToTop();

      // Use requestAnimationFrame to ensure it happens after paint
      requestAnimationFrame(() => {
        scrollToTop();
        // Double RAF for stubborn cases
        requestAnimationFrame(() => {
          scrollToTop();
      });
    });

      // Additional delayed attempts for async content loading
    const timeouts = [
        setTimeout(scrollToTop, 0),
        setTimeout(scrollToTop, 10),
        setTimeout(scrollToTop, 50),
        setTimeout(scrollToTop, 100),
        setTimeout(scrollToTop, 200)
    ];

    return () => {
      timeouts.forEach(timeout => clearTimeout(timeout));
    };
    }
  }, [location.pathname, location.search, location.hash]);

  return children;
};

export default ScrollToTopRouter;
